import client from './client'

export default {
  carts: () => `/carts`,
  session: () => `/sessions`,
  profiles: () => `/profiles`,
  addresses: () => `/addresses`,
  restaurant: () => `/restaurants`,
}

export function getOrders(params) {
  return client().get('/orders', { params })
    .then(response => response.data)
}
export function getOrder(order_id) {
  return client().get(`/orders/${order_id}`)
    .then(response => response.data)
}
export function isValidOrder(params) {
  return client().post('/carts/is_valid', params)
    .then(response => response.data)
}

export function getCategories() {
  return client().get(`/categories`)
    .then(response => response.data)
}

export function getMenuItems(params) {
  return client().get(`/menu_items`, { params })
    .then(response => response.data)
}
export function getMenuItem(menu_item_id) {
  return client().get(`/menu_items/${menu_item_id}`)
    .then(response => response.data)
}

export function getFavouriteItems() {
  return client().get('/favourite_items')
    .then(response => response.data)
}
export function createFavouriteItem(favourite_items) {
  return client().post('/favourite_items', favourite_items)
    .then(response => response.data)
    .catch(error => error.response)
}
export function destroyFavouriteItem(favourite_item_id) {
  return client().delete(`/favourite_items/${favourite_item_id}`)
    .then(response => response.data)
    .catch(error => error.response)
}

export function getDeals() {
  return client().get('/deals')
    .then(response => response.data)
}
export function getDeal(deal_id) {
  return client().get(`/deals/${deal_id}`)
    .then(response => response.data)
}

export function getCards() {
  return client().get('/cards')
    .then(response => response.data)
}
export function createCard(token) {
  return new Promise((resolve, reject) => {
    client().post('/cards', token)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response))
  })
}
export function destroyCard(card_id) {
  return client().delete(`/cards/${card_id}`)
    .then(response => response.data)
    .catch(error => error.response)
}

export function createOrderPayment(params) {
  return new Promise((resolve, reject) => {
    client().post('/order_payments', params)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response))
  })
}

export function isValidAddress(params) {
  return new Promise((resolve, reject) => {
    client().post('/carts/is_valid_address', params)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response))
  })
}
